import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import useSubscriptionAccess from "./useSubscriptionAccess";
import AddUsers from "./AddUsers";

const SubscriptionAccess = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    subscriptionAccessList,
    subscriptionAccessState,
    closeModal,
    setSubscriptionAccessState,
    handleEditAction,
    updateSubscriptionAccessTableHeadData,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useSubscriptionAccess();

  return (
    <>
      <HeadingGroup
        title="Subscription Access"
        className={`pro-mb-4`}
      ></HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: subscriptionAccessState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={true}
        />
        {subscriptionAccessList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={subscriptionAccessList?.data?.result || []}
            uniqueID={"_id"}
            fields={subscriptionAccessList?.fields || {}}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleEdit={handleEditAction}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={subscriptionAccessState?.clearSelection}
            perpage={subscriptionAccessState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={subscriptionAccessList?.edit_permission}
            showCheckBox={subscriptionAccessList?.edit_permission}
          />
        )}

        {subscriptionAccessList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={subscriptionAccessState?.currentPage}
            totalPageCount={Math.ceil(
              subscriptionAccessList?.data?.total_count /
                subscriptionAccessState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === subscriptionAccessState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={subscriptionAccessList?.fields || []}
              moduleId={subscriptionAccessList?.module_id}
              updateData={updateSubscriptionAccessTableHeadData}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={subscriptionAccessState.showModal}
          handleClose={() => closeModal()}
          title={`Update Subscription Access`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <AddUsers
              refetch={refetch}
              subscriptionAccessState={subscriptionAccessState}
              setSubscriptionAccessState={setSubscriptionAccessState}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default SubscriptionAccess;
